import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { logoutUser } from "../../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import withRouter from "../../Components/Common/withRouter";

const Logout = () => {
  const dispatch = useDispatch();

  const { isUserLogout } = useSelector((state) => ({
    isUserLogout: state.Login.isUserLogout,
  }));

  useEffect(() => {
    // Remove user data from localStorage
    localStorage.removeItem("authUser");

    // Dispatch your logout logic
    dispatch(logoutUser());
  }, [dispatch]);

  // Redirect to login after logout is confirmed
  if (isUserLogout) {
    return <Navigate to="/login" />;
  }

  return <></>;
};

export default withRouter(Logout);
